import React from "react";
import PropTypes from "prop-types";

/**
 * Inline field error message displayed below a form input.
 *
 * Renders an error icon and message text. Linked to its input via
 * `aria-describedby` on the input pointing to this element's `id`.
 * Uses `role="alert"` so screen readers announce the error without
 * requiring re-focus (WCAG 4.1.3 Status Messages, AA).
 *
 * @example
 * <FieldError id="event-name-error" message="Event Name is required" />
 */
export const FieldError = ({ id, message }) => {
  if (!message) {
    return null;
  }

  return (
    <div id={id} className="field-error" role="alert">
      <i
        className="fa fa-exclamation-circle field-error__icon"
        aria-hidden="true"
      />
      <span className="field-error__text">{message}</span>
    </div>
  );
};

FieldError.propTypes = {
  /** Unique ID — the input references this via aria-describedby */
  id: PropTypes.string.isRequired,
  /** Error message text. Component renders nothing when falsy. */
  message: PropTypes.string
};
